import { toLocalizedRiotUrl } from './../utils/language';
const config =
    window && window.sellingGlobalConfig
        ? { ...window.sellingGlobalConfig }
        : {};

config.imageSizeX = 200;
config.imageSizeY = 150;
config.maxTemplates = 100;
config.domainNameCategoryId = 344477;
config.URL_BASE = toLocalizedRiotUrl('/selling/');
config.RIOT_MOUNTPOINT = 'syi';

export default config;
